import React, { useCallback, useEffect, useState } from "react";
import { Flex } from "@chakra-ui/react";
import { Get } from "api";
import { NAVBAR_HEIGHT } from "components/navbar/NavbarAdmin";
import { PartnerData } from "views/admin/partnerDetail/types";
import AccountManagerView from "views/admin/partnerDetail/components/AccountManagerView";
import PartnerDetailView from "views/admin/partnerDetail/components/PartnerDetailView";
import ResetPartnerPasswordView from "views/admin/partnerDetail/components/ResetPartnerPasswordView";
import APIKeysView from "views/admin/partnerDetail/components/APIKeysView";
import PartnerAppsView from "views/admin/partnerDetail/components/PartnerAppsView";
import CouponsView from "views/admin/partnerDetail/components/CouponsView";
import ResendInvoiceView from "views/admin/partnerDetail/components/ResendInvoiceView";
import DeductionsView from "views/admin/partnerDetail/components/DeductionsView";
import AMUpdatesView from "views/admin/partnerDetail/components/AMUpdatesView";
import useAdmin from "hooks/useAdmin";

const PartnerDetail = () => {
  document.title = "Gamelight - Partner Details";
  const isAdmin = useAdmin();

  const [partnerData, setPartnerData] = useState<PartnerData | null>(null);
  const [partnerDataLoading, setPartnerDataLoading] = useState(false);

  const getPartnerId = (): number | null => {
    const urlParts = window.location.href.split("/");
    const parsedId = parseInt(urlParts[urlParts.length - 1], 10);
    return isNaN(parsedId) ? null : parsedId;
  };

  const partnerId = getPartnerId();

  const getPartnerDetails = useCallback(async (_partnerId: number) => {
    if (!_partnerId) return;
    setPartnerDataLoading(true);
    try {
      const partnerDetailResponse = await Get(`/manage/partners/${_partnerId}`);
      if (partnerDetailResponse) {
        setPartnerData({
          ...partnerDetailResponse,
          secondaryInvoiceMails:
            partnerDetailResponse.secondaryInvoiceMails ?? [],
        });
      }
    } catch (error) {
      console.warn(error);
    } finally {
      setPartnerDataLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!partnerId) return;

    getPartnerDetails(partnerId);
  }, [getPartnerDetails, partnerId]);

  return (
    <Flex flex={1} flexDir="column" minH={"90vh"} pt={NAVBAR_HEIGHT}>
      <AccountManagerView
        managers={partnerData?.accountManagers}
        partnerId={partnerId}
        partnerDataLoading={partnerDataLoading}
        setPartnerData={setPartnerData}
      />
      <PartnerDetailView data={partnerData} partnerId={partnerId} />
      <ResetPartnerPasswordView partnerId={partnerId} />
      <APIKeysView
        apiKey={partnerData?.apiKey}
        audienceApiKey={partnerData?.audienceApiKey}
      />
      <PartnerAppsView apps={partnerData?.apps} partnerId={partnerId} />
      <CouponsView
        redeemedCoupons={partnerData?.redeemedCoupons}
        getPartnerDetails={getPartnerDetails}
        partnerId={partnerId}
      />
      {isAdmin && <ResendInvoiceView partnerId={partnerId} />}
      {isAdmin && (
        <DeductionsView
          deductions={partnerData?.deductions}
          partnerId={partnerId}
          setPartnerData={setPartnerData}
        />
      )}
      <AMUpdatesView
        partnerId={partnerId}
        accountManagers={partnerData?.accountManagers || []}
      />
    </Flex>
  );
};

export default PartnerDetail;
